module.exports = __webpack_public_path__ + "static/template-team-member-1-60694281c8595b1634e3f7e62990503e.jpg";